import React from "react";
import { Grid, Icon, Segment, Header } from "semantic-ui-react";

const Services = props => (
  <Grid.Column computer={5} tablet={14} mobile={16}>
    <Segment style={{marginTop: '1em'}}>
      <Header>
        <Icon name="arrow right" />
        {props.name}
      </Header>

      <p>{props.info}</p>

      <p />
    </Segment>
  </Grid.Column>
);

export default Services;



// WEBPACK FOOTER //
// ./src/ServiceItem.js